var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container-page"}},[_c('Top',{attrs:{"id":"top"}}),_c('Carousel',{attrs:{"startIndex":this.$route.query.index}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }